export enum PresetsTab {
  Presets = 'Presets',
  Models = 'Models'
}

export type IInsight = Microsoft.VideoIndexer.Live.Contracts.IBuiltInInsight & Microsoft.VideoIndexer.Live.Contracts.ICustomInsight;

export interface IUILiveInsightType extends IInsight {
  insightType: string;
  modelTypeDisplayName: string;
  isNew?: boolean;
  isUpdated?: boolean;
}

export enum LiveInsightName {
  People = 'People',
  Vehicle = 'Vehicle'
}

export enum SupportedModel {
  YoloX = 'YoloX',
  CustomObjectDetection = 'CustomObjectDetection',
  CustomSituation = 'CustomSituation',
  ObjectDetection = 'ObjectDetection'
}

export type SupportedModelDisplayName = { [key in SupportedModel]: string };
